export function extractPasswordResetTokenFromHash(hash = "") {
    const normalizedHash = String(hash || "").replace(/^#/, "");
    if (!normalizedHash) {
        return null;
    }

    const params = new URLSearchParams(normalizedHash);
    const token = params.get("token");
    return token ? token.trim() : null;
}

export function consumePasswordResetTokenFromUrl(browserWindow = window) {
    const token = extractPasswordResetTokenFromHash(browserWindow.location.hash);
    if (token) {
        const cleanUrl = `${browserWindow.location.pathname}${browserWindow.location.search}`;
        browserWindow.history.replaceState(null, "", cleanUrl);
    }
    return token;
}
